import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export type SupportedLanguage = 'en' | 'fr';

export interface UserPreferencePayload {
  preferred_language: SupportedLanguage;
}

@Injectable({ providedIn: 'root' })
export class UserPreferenceService {
  constructor(private readonly http: HttpClient) {}

  getPreferences(): Observable<UserPreferencePayload> {
    return this.http.get<UserPreferencePayload>(`${environment.apiUrl}/auth/preferences/`);
  }

  updateLanguage(preferredLanguage: SupportedLanguage): Observable<UserPreferencePayload> {
    return this.http.patch<UserPreferencePayload>(`${environment.apiUrl}/auth/preferences/`, {
      preferred_language: preferredLanguage,
    });
  }
}
